import { fetchUtils } from 'admin-on-rest';
import WPRestServer from './WPRestServer';

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
}

export default ( url ) => {
	return WPRestServer( url, httpClient );
}



// WEBPACK FOOTER //
// ./src/rest/WPRestClient.js